import React, {useEffect} from 'react';
import {documentToHtmlString} from '@contentful/rich-text-html-renderer';
import {assignInlineVars} from '@vanilla-extract/dynamic';

import {useGetPromotionalBanner} from '#apollo/schema';

import * as css from './HeaderPromotionalBanner.css';

interface HeaderPromotionalBannerProps {
  onLoad: () => void;
}

export const HeaderPromotionalBanner: React.FC<HeaderPromotionalBannerProps> = ({onLoad}) => {
  const {data} = useGetPromotionalBanner();

  useEffect(() => {
    if (data?.promotionalBanner?.isBannerActive) {
      onLoad();
    }
  }, [data, onLoad]);

  if (!data?.promotionalBanner?.isBannerActive) {
    return null;
  }

  const {backgroundColor, textColor, content} = data?.promotionalBanner ?? {};
  const contentParsed = content ? JSON.parse(content) : '';
  const contentToRender = content ? documentToHtmlString(contentParsed) : '';

  return (
    <div
      style={assignInlineVars({
        [css.backgroundColorVar]: backgroundColor ?? '',
      })}
      className={css.root}>
      <div
        style={assignInlineVars({
          [css.textColorVar]: textColor ?? '',
        })}
        className={css.text}
        dangerouslySetInnerHTML={{
          __html: contentToRender,
        }}
      />
    </div>
  );
};
